import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "../paginas/Home";

export default function ClienteRutas() {
  return (
    <Routes>
      <Route path="" element={<Home />} />
      {/* Puedes agregar más rutas públicas aquí */}
    </Routes>
  );
}
